import InputLabel from './Label';
import inputLabelStyles from './label.module.scss';

export { InputLabel, inputLabelStyles };

export default InputLabel;
